// This file is auto-generated

import { Message, BinaryWriter, BinaryReader } from "google-protobuf";

import * as dep_1 from "./../tolemac/pub/filter";
import * as dep_2 from "./user";

export interface IPackage {
    id?: number;
    ref?: string;
    name?: string;
    goals?: string[];
    trainings?: IPackageTraining[];
    hasApplicationProcess?: boolean;
    commissionTrainer?: dep_2.IUser;

}
export class Package implements IPackage {

    id?: number;
    ref?: string;
    name?: string;
    goals?: string[];
    trainings?: PackageTraining[];
    hasApplicationProcess?: boolean;
    commissionTrainer?: dep_2.User;

    constructor(data?: Partial<IPackage>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MPackage extends Message implements Package {

    constructor(data?: Partial<IPackage>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [6,7], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("ref" in data && data.ref != undefined) this.ref = data.ref;
            if ("name" in data && data.name != undefined) this.name = data.name;
            if ("goals" in data && data.goals != undefined) this.goals = data.goals;
            if ("trainings" in data && data.trainings != undefined) this.trainings = data.trainings.map(d => new MPackageTraining(d));
            if ("hasApplicationProcess" in data && data.hasApplicationProcess != undefined) this.hasApplicationProcess = data.hasApplicationProcess;
            if ("commissionTrainer" in data && data.commissionTrainer != undefined) this.commissionTrainer = new dep_2.MUser(data.commissionTrainer);
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get ref(): string {
        return Message.getField(this, 2) as string;
    }
    set ref(value: string) {
        Message.setField(this, 2, value);
    }

    get name(): string {
        return Message.getField(this, 3) as string;
    }
    set name(value: string) {
        Message.setField(this, 3, value);
    }

    get goals(): string[] {
        return Message.getField(this, 6) as string[];
    }
    set goals(value: string[]) {
        Message.setField(this, 6, value);
    }

    get trainings(): MPackageTraining[] {
        return Message.getRepeatedWrapperField(this, MPackageTraining, 7);
    }
    set trainings(value: MPackageTraining[]) {
        Message.setRepeatedWrapperField(this, 7, value);
    }

    get hasApplicationProcess(): boolean {
        return Message.getField(this, 8) as boolean;
    }
    set hasApplicationProcess(value: boolean) {
        Message.setField(this, 8, value);
    }

    get commissionTrainer(): dep_2.MUser {
        return Message.getWrapperField(this, dep_2.MUser, 9);
    }
    set commissionTrainer(value: dep_2.MUser) {
        Message.setWrapperField(this, 9, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Package() : {} as Package;
        if (this.id != undefined) data.id = this.id;
        if (this.ref != undefined) data.ref = this.ref;
        if (this.name != undefined) data.name = this.name;
        if (this.goals?.length) data.goals = this.goals;
        if (this.trainings.length) data.trainings = this.trainings.map(d => d.toObject(includeInstance));

        if (this.hasApplicationProcess != undefined) data.hasApplicationProcess = this.hasApplicationProcess;
        if (this.commissionTrainer != undefined) data.commissionTrainer = this.commissionTrainer.toObject(includeInstance);
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.ref !== undefined) writer.writeString(2, this.ref);
                if (this.name !== undefined) writer.writeString(3, this.name);
                if (this.goals !== undefined) writer.writeRepeatedString(6, this.goals);
                if (this.trainings !== undefined) writer.writeRepeatedMessage(7, this.trainings, (i) => i.serialize(writer));
                if (this.hasApplicationProcess !== undefined) writer.writeBool(8, this.hasApplicationProcess);
                if (this.commissionTrainer !== undefined) writer.writeMessage(9, this.commissionTrainer, () => this.commissionTrainer.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IPackage): Uint8Array {
        return (data instanceof Message ? (data as MPackage) : new MPackage(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MPackage {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MPackage();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.ref = reader.readString();
                    break;
            case 3:
                    message.name = reader.readString();
                    break;
            case 6:
                    Message.addToRepeatedField(message, 6, reader.readString());
                    break;
            case 7:
                    reader.readMessage(message.trainings, () => Message.addToRepeatedWrapperField(message, 7, MPackageTraining.deserialize(reader), MPackageTraining));
                    break;
            case 8:
                    message.hasApplicationProcess = reader.readBool();
                    break;
            case 9:
                    reader.readMessage(message.commissionTrainer, () => message.commissionTrainer = dep_2.MUser.deserialize(reader));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MPackage {
        return MPackage.deserializeBinaryFromReader(new MPackage(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MPackage, reader: BinaryReader) {
        return Object.assign(msg, MPackage.deserialize(reader))
    };

}
export interface IPackageTraining {
    id?: number;
    ref?: string;
    moodleRef?: number;
    name?: string;
    reviewTime?: number;
    rawWorkDuration?: number;
    isArchived?: boolean;
    isHiddenInFilters?: boolean;
    modules?: IPackageTrainingModule[];

}
export class PackageTraining implements IPackageTraining {

    id?: number;
    ref?: string;
    moodleRef?: number;
    name?: string;
    reviewTime?: number;
    rawWorkDuration?: number;
    isArchived?: boolean;
    isHiddenInFilters?: boolean;
    modules: PackageTrainingModule[];

    constructor(data?: Partial<IPackageTraining>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MPackageTraining extends Message implements PackageTraining {

    constructor(data?: Partial<IPackageTraining>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [10], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("ref" in data && data.ref != undefined) this.ref = data.ref;
            if ("moodleRef" in data && data.moodleRef != undefined) this.moodleRef = data.moodleRef;
            if ("name" in data && data.name != undefined) this.name = data.name;
            if ("reviewTime" in data && data.reviewTime != undefined) this.reviewTime = data.reviewTime;
            if ("rawWorkDuration" in data && data.rawWorkDuration != undefined) this.rawWorkDuration = data.rawWorkDuration;
            if ("isArchived" in data && data.isArchived != undefined) this.isArchived = data.isArchived;
            if ("isHiddenInFilters" in data && data.isHiddenInFilters != undefined) this.isHiddenInFilters = data.isHiddenInFilters;
            if ("modules" in data && data.modules != undefined) this.modules = data.modules.map(d => new MPackageTrainingModule(d));
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get ref(): string {
        return Message.getField(this, 2) as string;
    }
    set ref(value: string) {
        Message.setField(this, 2, value);
    }

    get moodleRef(): number {
        return Message.getField(this, 3) as number;
    }
    set moodleRef(value: number) {
        Message.setField(this, 3, value);
    }

    get name(): string {
        return Message.getField(this, 4) as string;
    }
    set name(value: string) {
        Message.setField(this, 4, value);
    }

    get reviewTime(): number {
        return Message.getField(this, 5) as number;
    }
    set reviewTime(value: number) {
        Message.setField(this, 5, value);
    }

    get rawWorkDuration(): number {
        return Message.getField(this, 6) as number;
    }
    set rawWorkDuration(value: number) {
        Message.setField(this, 6, value);
    }

    get isArchived(): boolean {
        return Message.getField(this, 7) as boolean;
    }
    set isArchived(value: boolean) {
        Message.setField(this, 7, value);
    }

    get isHiddenInFilters(): boolean {
        return Message.getField(this, 8) as boolean;
    }
    set isHiddenInFilters(value: boolean) {
        Message.setField(this, 8, value);
    }

    get modules(): MPackageTrainingModule[] {
        return Message.getRepeatedWrapperField(this, MPackageTrainingModule, 10);
    }
    set modules(value: MPackageTrainingModule[]) {
        Message.setRepeatedWrapperField(this, 10, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new PackageTraining() : {} as PackageTraining;
        if (this.id != undefined) data.id = this.id;
        if (this.ref != undefined) data.ref = this.ref;
        if (this.moodleRef != undefined) data.moodleRef = this.moodleRef;
        if (this.name != undefined) data.name = this.name;
        if (this.reviewTime != undefined) data.reviewTime = this.reviewTime;
        if (this.rawWorkDuration != undefined) data.rawWorkDuration = this.rawWorkDuration;
        if (this.isArchived != undefined) data.isArchived = this.isArchived;
        if (this.isHiddenInFilters != undefined) data.isHiddenInFilters = this.isHiddenInFilters;
        data.modules = this.modules.map(d => d.toObject(includeInstance));
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.ref !== undefined) writer.writeString(2, this.ref);
                if (this.moodleRef !== undefined) writer.writeInt32(3, this.moodleRef);
                if (this.name !== undefined) writer.writeString(4, this.name);
                if (this.reviewTime !== undefined) writer.writeInt32(5, this.reviewTime);
                if (this.rawWorkDuration !== undefined) writer.writeInt32(6, this.rawWorkDuration);
                if (this.isArchived !== undefined) writer.writeBool(7, this.isArchived);
                if (this.isHiddenInFilters !== undefined) writer.writeBool(8, this.isHiddenInFilters);
                if (this.modules !== undefined) writer.writeRepeatedMessage(10, this.modules, (i) => i.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IPackageTraining): Uint8Array {
        return (data instanceof Message ? (data as MPackageTraining) : new MPackageTraining(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MPackageTraining {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MPackageTraining();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.ref = reader.readString();
                    break;
            case 3:
                    message.moodleRef = reader.readInt32();
                    break;
            case 4:
                    message.name = reader.readString();
                    break;
            case 5:
                    message.reviewTime = reader.readInt32();
                    break;
            case 6:
                    message.rawWorkDuration = reader.readInt32();
                    break;
            case 7:
                    message.isArchived = reader.readBool();
                    break;
            case 8:
                    message.isHiddenInFilters = reader.readBool();
                    break;
            case 10:
                    reader.readMessage(message.modules, () => Message.addToRepeatedWrapperField(message, 10, MPackageTrainingModule.deserialize(reader), MPackageTrainingModule));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MPackageTraining {
        return MPackageTraining.deserializeBinaryFromReader(new MPackageTraining(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MPackageTraining, reader: BinaryReader) {
        return Object.assign(msg, MPackageTraining.deserialize(reader))
    };

}
export interface IPackageTrainingModule {
    id?: number;
    moodleRef?: number;
    name?: string;
    goal?: string;
    rawWorkDuration?: number;
    sortOrder?: number;
    modality?: string;
    traineesWork?: string;
    sections?: IPackageTrainingSection[];

}
export class PackageTrainingModule implements IPackageTrainingModule {

    id?: number;
    moodleRef?: number;
    name?: string;
    goal?: string;
    rawWorkDuration?: number;
    sortOrder?: number;
    modality?: string;
    traineesWork?: string;
    sections: PackageTrainingSection[];

    constructor(data?: Partial<IPackageTrainingModule>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MPackageTrainingModule extends Message implements PackageTrainingModule {

    constructor(data?: Partial<IPackageTrainingModule>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [10], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("moodleRef" in data && data.moodleRef != undefined) this.moodleRef = data.moodleRef;
            if ("name" in data && data.name != undefined) this.name = data.name;
            if ("goal" in data && data.goal != undefined) this.goal = data.goal;
            if ("rawWorkDuration" in data && data.rawWorkDuration != undefined) this.rawWorkDuration = data.rawWorkDuration;
            if ("sortOrder" in data && data.sortOrder != undefined) this.sortOrder = data.sortOrder;
            if ("modality" in data && data.modality != undefined) this.modality = data.modality;
            if ("traineesWork" in data && data.traineesWork != undefined) this.traineesWork = data.traineesWork;
            if ("sections" in data && data.sections != undefined) this.sections = data.sections.map(d => new MPackageTrainingSection(d));
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get moodleRef(): number {
        return Message.getField(this, 2) as number;
    }
    set moodleRef(value: number) {
        Message.setField(this, 2, value);
    }

    get name(): string {
        return Message.getField(this, 3) as string;
    }
    set name(value: string) {
        Message.setField(this, 3, value);
    }

    get goal(): string {
        return Message.getField(this, 4) as string;
    }
    set goal(value: string) {
        Message.setField(this, 4, value);
    }

    get rawWorkDuration(): number {
        return Message.getField(this, 5) as number;
    }
    set rawWorkDuration(value: number) {
        Message.setField(this, 5, value);
    }

    get sortOrder(): number {
        return Message.getField(this, 6) as number;
    }
    set sortOrder(value: number) {
        Message.setField(this, 6, value);
    }

    get modality(): string {
        return Message.getField(this, 7) as string;
    }
    set modality(value: string) {
        Message.setField(this, 7, value);
    }

    get traineesWork(): string {
        return Message.getField(this, 8) as string;
    }
    set traineesWork(value: string) {
        Message.setField(this, 8, value);
    }

    get sections(): MPackageTrainingSection[] {
        return Message.getRepeatedWrapperField(this, MPackageTrainingSection, 10);
    }
    set sections(value: MPackageTrainingSection[]) {
        Message.setRepeatedWrapperField(this, 10, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new PackageTrainingModule() : {} as PackageTrainingModule;
        if (this.id != undefined) data.id = this.id;
        if (this.moodleRef != undefined) data.moodleRef = this.moodleRef;
        if (this.name != undefined) data.name = this.name;
        if (this.goal != undefined) data.goal = this.goal;
        if (this.rawWorkDuration != undefined) data.rawWorkDuration = this.rawWorkDuration;
        if (this.sortOrder != undefined) data.sortOrder = this.sortOrder;
        if (this.modality != undefined) data.modality = this.modality;
        if (this.traineesWork != undefined) data.traineesWork = this.traineesWork;
        data.sections = this.sections.map(d => d.toObject(includeInstance));
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.moodleRef !== undefined) writer.writeInt32(2, this.moodleRef);
                if (this.name !== undefined) writer.writeString(3, this.name);
                if (this.goal !== undefined) writer.writeString(4, this.goal);
                if (this.rawWorkDuration !== undefined) writer.writeInt32(5, this.rawWorkDuration);
                if (this.sortOrder !== undefined) writer.writeInt32(6, this.sortOrder);
                if (this.modality !== undefined) writer.writeString(7, this.modality);
                if (this.traineesWork !== undefined) writer.writeString(8, this.traineesWork);
                if (this.sections !== undefined) writer.writeRepeatedMessage(10, this.sections, (i) => i.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IPackageTrainingModule): Uint8Array {
        return (data instanceof Message ? (data as MPackageTrainingModule) : new MPackageTrainingModule(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MPackageTrainingModule {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MPackageTrainingModule();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.moodleRef = reader.readInt32();
                    break;
            case 3:
                    message.name = reader.readString();
                    break;
            case 4:
                    message.goal = reader.readString();
                    break;
            case 5:
                    message.rawWorkDuration = reader.readInt32();
                    break;
            case 6:
                    message.sortOrder = reader.readInt32();
                    break;
            case 7:
                    message.modality = reader.readString();
                    break;
            case 8:
                    message.traineesWork = reader.readString();
                    break;
            case 10:
                    reader.readMessage(message.sections, () => Message.addToRepeatedWrapperField(message, 10, MPackageTrainingSection.deserialize(reader), MPackageTrainingSection));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MPackageTrainingModule {
        return MPackageTrainingModule.deserializeBinaryFromReader(new MPackageTrainingModule(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MPackageTrainingModule, reader: BinaryReader) {
        return Object.assign(msg, MPackageTrainingModule.deserialize(reader))
    };

}
export interface IPackageTrainingSection {
    id?: number;
    moodleRef?: number;
    name?: string;
    /**
     * in minutes
     */
    workDuration?: number;
    sortOrder?: number;
    assigns?: IPackageTrainingAssign[];

}
export class PackageTrainingSection implements IPackageTrainingSection {

    id?: number;
    moodleRef?: number;
    name?: string;
    workDuration?: number;
    sortOrder?: number;
    assigns: PackageTrainingAssign[];

    constructor(data?: Partial<IPackageTrainingSection>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MPackageTrainingSection extends Message implements PackageTrainingSection {

    constructor(data?: Partial<IPackageTrainingSection>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [10], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("moodleRef" in data && data.moodleRef != undefined) this.moodleRef = data.moodleRef;
            if ("name" in data && data.name != undefined) this.name = data.name;
            if ("workDuration" in data && data.workDuration != undefined) this.workDuration = data.workDuration;
            if ("sortOrder" in data && data.sortOrder != undefined) this.sortOrder = data.sortOrder;
            if ("assigns" in data && data.assigns != undefined) this.assigns = data.assigns.map(d => new MPackageTrainingAssign(d));
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get moodleRef(): number {
        return Message.getField(this, 2) as number;
    }
    set moodleRef(value: number) {
        Message.setField(this, 2, value);
    }

    get name(): string {
        return Message.getField(this, 3) as string;
    }
    set name(value: string) {
        Message.setField(this, 3, value);
    }

    get workDuration(): number {
        return Message.getField(this, 5) as number;
    }
    set workDuration(value: number) {
        Message.setField(this, 5, value);
    }

    get sortOrder(): number {
        return Message.getField(this, 6) as number;
    }
    set sortOrder(value: number) {
        Message.setField(this, 6, value);
    }

    get assigns(): MPackageTrainingAssign[] {
        return Message.getRepeatedWrapperField(this, MPackageTrainingAssign, 10);
    }
    set assigns(value: MPackageTrainingAssign[]) {
        Message.setRepeatedWrapperField(this, 10, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new PackageTrainingSection() : {} as PackageTrainingSection;
        if (this.id != undefined) data.id = this.id;
        if (this.moodleRef != undefined) data.moodleRef = this.moodleRef;
        if (this.name != undefined) data.name = this.name;
        if (this.workDuration != undefined) data.workDuration = this.workDuration;
        if (this.sortOrder != undefined) data.sortOrder = this.sortOrder;
        data.assigns = this.assigns.map(d => d.toObject(includeInstance));
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.moodleRef !== undefined) writer.writeInt32(2, this.moodleRef);
                if (this.name !== undefined) writer.writeString(3, this.name);
                if (this.workDuration !== undefined) writer.writeInt32(5, this.workDuration);
                if (this.sortOrder !== undefined) writer.writeInt32(6, this.sortOrder);
                if (this.assigns !== undefined) writer.writeRepeatedMessage(10, this.assigns, (i) => i.serialize(writer));
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IPackageTrainingSection): Uint8Array {
        return (data instanceof Message ? (data as MPackageTrainingSection) : new MPackageTrainingSection(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MPackageTrainingSection {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MPackageTrainingSection();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.moodleRef = reader.readInt32();
                    break;
            case 3:
                    message.name = reader.readString();
                    break;
            case 5:
                    message.workDuration = reader.readInt32();
                    break;
            case 6:
                    message.sortOrder = reader.readInt32();
                    break;
            case 10:
                    reader.readMessage(message.assigns, () => Message.addToRepeatedWrapperField(message, 10, MPackageTrainingAssign.deserialize(reader), MPackageTrainingAssign));
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MPackageTrainingSection {
        return MPackageTrainingSection.deserializeBinaryFromReader(new MPackageTrainingSection(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MPackageTrainingSection, reader: BinaryReader) {
        return Object.assign(msg, MPackageTrainingSection.deserialize(reader))
    };

}
export interface IPackageTrainingAssign {
    id?: number;
    moodleRef?: number;
    name?: string;

}
export class PackageTrainingAssign implements IPackageTrainingAssign {

    id?: number;
    moodleRef?: number;
    name?: string;

    constructor(data?: Partial<IPackageTrainingAssign>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MPackageTrainingAssign extends Message implements PackageTrainingAssign {

    constructor(data?: Partial<IPackageTrainingAssign>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("id" in data && data.id != undefined) this.id = data.id;
            if ("moodleRef" in data && data.moodleRef != undefined) this.moodleRef = data.moodleRef;
            if ("name" in data && data.name != undefined) this.name = data.name;
        }
    }

    get id(): number {
        return Message.getField(this, 1) as number;
    }
    set id(value: number) {
        Message.setField(this, 1, value);
    }

    get moodleRef(): number {
        return Message.getField(this, 2) as number;
    }
    set moodleRef(value: number) {
        Message.setField(this, 2, value);
    }

    get name(): string {
        return Message.getField(this, 3) as string;
    }
    set name(value: string) {
        Message.setField(this, 3, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new PackageTrainingAssign() : {} as PackageTrainingAssign;
        if (this.id != undefined) data.id = this.id;
        if (this.moodleRef != undefined) data.moodleRef = this.moodleRef;
        if (this.name != undefined) data.name = this.name;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.id !== undefined) writer.writeInt32(1, this.id);
                if (this.moodleRef !== undefined) writer.writeInt32(2, this.moodleRef);
                if (this.name !== undefined) writer.writeString(3, this.name);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IPackageTrainingAssign): Uint8Array {
        return (data instanceof Message ? (data as MPackageTrainingAssign) : new MPackageTrainingAssign(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MPackageTrainingAssign {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MPackageTrainingAssign();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    message.id = reader.readInt32();
                    break;
            case 2:
                    message.moodleRef = reader.readInt32();
                    break;
            case 3:
                    message.name = reader.readString();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MPackageTrainingAssign {
        return MPackageTrainingAssign.deserializeBinaryFromReader(new MPackageTrainingAssign(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MPackageTrainingAssign, reader: BinaryReader) {
        return Object.assign(msg, MPackageTrainingAssign.deserialize(reader))
    };

}
export interface IPackages {
    values?: IPackage[];
    count?: number;

}
export class Packages implements IPackages {

    values: Package[];
    count?: number;

    constructor(data?: Partial<IPackages>) {
        if (data)
            Object.keys(data).forEach(d => this[d] = data[d])
    }
}
export class MPackages extends Message implements Packages {

    constructor(data?: Partial<IPackages>) {
        super();
        Message.initialize(this, Array.isArray(data) ? data : [], 0, -1, [1], []);
        if (!Array.isArray(data) && typeof data == "object") {
            if ("values" in data && data.values != undefined) this.values = data.values.map(d => new MPackage(d));
            if ("count" in data && data.count != undefined) this.count = data.count;
        }
    }

    get values(): MPackage[] {
        return Message.getRepeatedWrapperField(this, MPackage, 1);
    }
    set values(value: MPackage[]) {
        Message.setRepeatedWrapperField(this, 1, value);
    }

    get count(): number {
        return Message.getField(this, 2) as number;
    }
    set count(value: number) {
        Message.setField(this, 2, value);
    }

    toObject(includeInstance: boolean = true) {
        const data = includeInstance ? new Packages() : {} as Packages;
        data.values = this.values.map(d => d.toObject(includeInstance));
        if (this.count != undefined) data.count = this.count;
        return data;
    }

    serialize(): Uint8Array
    serialize(w: BinaryWriter): undefined
    serialize(w?: BinaryWriter): Uint8Array | undefined {
        const writer = w || new BinaryWriter();
        try {
                if (this.values !== undefined) writer.writeRepeatedMessage(1, this.values, (i) => i.serialize(writer));
                if (this.count !== undefined) writer.writeInt32(2, this.count);
        
        } catch (e: any) {
            if (!w) console.error(e)
            throw e
        }
        if (!w) return writer.getResultBuffer();
    }

    serializeBinary(): Uint8Array {
        return this.serialize();
    }

    static serializeBinary(data?: IPackages): Uint8Array {
        return (data instanceof Message ? (data as MPackages) : new MPackages(data)).serializeBinary()
    }


    static deserialize(bytes: Uint8Array | BinaryReader): MPackages {
        const reader = bytes instanceof Uint8Array ? new BinaryReader(bytes) : bytes;
        const message = new MPackages();
        while (reader.nextField()) {
            if (reader.isEndGroup())
                break;
            switch (reader.getFieldNumber()) {
            case 1:
                    reader.readMessage(message.values, () => Message.addToRepeatedWrapperField(message, 1, MPackage.deserialize(reader), MPackage));
                    break;
            case 2:
                    message.count = reader.readInt32();
                    break;
            
                default: reader.skipField();
            }
        }
        return message;
    }

    static override deserializeBinary(bytes: Uint8Array): MPackages {
        return MPackages.deserializeBinaryFromReader(new MPackages(), new BinaryReader(bytes));
    }

    static override deserializeBinaryFromReader(msg: MPackages, reader: BinaryReader) {
        return Object.assign(msg, MPackages.deserialize(reader))
    };

}
                        




export default () => {}